import Model from "src/app/common/model";

export default class ContinuousWaterMonitoringModel extends Model {
    filename?: string;
    serial_number?: string;
    business_id?: string;
    conductivity?: number;
    device_id?: string;
    do2?: number;
    farm_site_id?: string;
    person_id?: string;
    pH?: number;
    pond_culture_id?: number;
    pond_name?: string;
    salinity?: number;
    section_name?: string;
    tank_id?: number;
    temperature?: number;
    test_type?: number;
    time?: Date;
    time_interval?: number;
    turbidity?: number;
    
constructor() {
        super();
    }
}
